var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_kng_template_btn_choose_micro" /* 选择微课 */),
        size: "960px",
        visible: _vm.visible,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("yxtbiz-tcm-select", {
        ref: "tcmSelect",
        attrs: {
          hasSelected: _vm.selected,
          chooseLimit: _vm.selectableLength,
          tcmStatus: 1,
        },
        on: { select: _vm.onSelect },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("pc_kng_common_btn_cancel")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_kng_common_btn_confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }